<div class="map-frame">
  <div id={{inject.div_name}} class="map"> 
   </div>
</div>

